import React from 'react';



const B2 = () => {
  return (
    <div className='page1'>
      <div className='overall'>
        <h2 className='heading'>தாய்ப்பால் ஊட்டுதல்</h2>
        <h3 className='subheading'>தாய்ப்பால் பற்றிய கேள்விகள்</h3>

      </div>
      <div className='answer'>
        <h3  style={{ color: '#BB0297' }}> தாய்ப்பால் கொடுப்பது தொடர்பான பொதுவான கேள்விகள்:-</h3><br></br>


        <h4>தாய்மார்கள் எவ்வளவு காலம் தாய்ப்பால் கொடுக்க வேண்டும்?</h4>

        <p>வாழ்க்கையின் முதல் ஆறு மாதங்களுக்கு பிரத்தியேக தாய்ப்பால் கொடுக்க வேண்டும் ஆறு மாதங்களுக்குப் பிறகு, குறைந்தபட்சம் 12 மாதங்கள் வரை தொடர்ந்து தாய்ப்பால் கொடுக்க வேண்டும். உலக சுகாதார நிறுவனம் குறைந்தது 24 மாதங்களுக்கு தாய்ப்பால் கொடுக்க பரிந்துரைக்கிறது.</p>
        <br />

        <h4>என் குழந்தைக்கு நான் எவ்வளவு அடிக்கடி உணவளிக்க வேண்டும்?</h4>

        <p>பொதுவாக ஒவ்வொரு மார்பகத்திலும் குறைந்தது 10-15 நிமிடங்கள். குறைந்தது ஒவ்வொரு 15-3 மணி நேரத்திற்கும் உணவளிக்க வேண்டும்.</p>
        <br />

        <h4>என் குழந்தைக்கு கூடுதல் தண்ணீர் அல்லது வைட்டமின்கள் தேவையா?</h4>

        தாயின் பால் தேவையான அனைத்து திரவங்களையும் ஊட்டச்சத்துக்களையும் வழங்குகிறது. தாய்ப்பால் கொடுக்கும் முதல் ஆறு மாதங்களில் நீங்கள் தண்ணீர், வைட்டமின்கள் அல்லது இரும்புச் சத்துக்களை சேர்க்க வேண்டியதில்லை. 6மாத வயதிற்குள் குழந்தைகளுக்கு இரும்புச்சத்து கொண்ட உணவுகளை வழங்கத் தொடங்குங்கள்.

      </div>
    </div>


  );
};

export default B2
